export const GIGYA_BRAND_IMAGE_FAVORITES = 'https://static.talparadio.nl/images/juke/favorite-login-register.jpg';
export const GIGYA_DEFAULT_JUKE_BRAND_IMAGE =
  'https://images.ctfassets.net/0w1d9hjfek5f/1l9yeXuVq0uQs02YGCmy2w/e65feef3218fd0c7862e868a7c72d33c/Juke.jpg';
export const AUDIO_HD_GIGYA_IMAGE = 'https://static.talparadio.nl/images/juke/hd-audio-login-register.png';
export const GIGYA_SCREENSET_MOBILE_VIEW_BREAKPOINT = 965;
